/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Permission_See_All_Chats_HintInputs */



/**
* | output |
* | --- |
* | "Takes effect when private chats is turned on." |
*
* @param {Projects_Permission_See_All_Chats_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_permission_see_all_chats_hint = /** @type {((inputs?: Projects_Permission_See_All_Chats_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Permission_See_All_Chats_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gilt, sobald Private Chats aktiviert ist.")
	return /** @type {LocalizedString} */ ("Takes effect when private chats is turned on.")
});